<template>
  <span class="diag-supported el-icon-success"></span>
</template>
<script>
export default {
  name: 'diag-supported',
}
</script>
<style lang="less">
.diag-supported {
  color: #67c23a;
}
</style>